module.exports = __webpack_public_path__ + "static/img/12.d42885d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/7/12.png
// module id = g2tI
// module chunks = 0